import { BehaviorSubject } from 'rxjs';

export const isStickyHeader$ = new BehaviorSubject(false);
export const isStickyHeader = isStickyHeader$.asObservable();